const BaseComponent = require('base/base-component');

class Card extends BaseComponent {
  init () {
    const notice=this.$el.find('#major-notice');
    const rule=this.$el.find('#new-rule');
    notice.click(this.majorShow);
    rule.click(this.ruleShow);
    this.majorShow();
  }
  majorShow() {
    $('#major-notice').addClass('active');
    $('#new-rule').removeClass('active');
    $('.sx-home-major-notice .card__body .list:first-child ').addClass('active');
    $('.sx-home-major-notice .card__body .list:last-child ').removeClass('active');
    $('.sx-major-rule-more').attr('href','/sxCategory13/sxCategory103/index.html');
  }
  ruleShow () {
    $('#major-notice').removeClass('active');
    $('#new-rule').addClass('active');
    $('.sx-home-major-notice .card__body .list:first-child ').removeClass('active');
    $('.sx-home-major-notice .card__body .list:last-child ').addClass('active');
    $('.sx-major-rule-more').attr('href','/sxCategory14/index.html');
  }
}
module.exports = Card;
